export const FETCH_ASSET_COLUMNS_URL = `${process.env.REACT_APP_API_URL}/assets/query-columns`;
export const FETCH_ASSET_LIST = `${process.env.REACT_APP_API_URL}/assets`;
